import React from 'react';
import { faFileContract } from '@fortawesome/pro-light-svg-icons';
import { Box, FaSvg, Copyable, themeUtils as tu } from '@zen-common/components-base';
import { ExplorerLink } from '@zen/common-app-parts';
import styled from 'styled-components';
import { TopExternalLink, TopLinksContainer } from './TopLinks';

export default function TopParagraph({ link, address, name, ...props }) {
  return (
    <Box {...props}>
      {name && (
        <SubTitle>
          <Box mr="2" fontWeight="500">
            Contract Name:
          </Box>
          <Copyable value={address}>
            <ExplorerLink path={`contracts/${address}`}>{name}</ExplorerLink>
          </Copyable>
        </SubTitle>
      )}
      <SubTitle>
        <Box mr="2" fontWeight="500">
          Contract address:
        </Box>
        <Copyable value={address}>
          <ExplorerLink path={`contracts/${address}`}>{address}</ExplorerLink>
        </Copyable>
      </SubTitle>
      {link && (
        <TopLinksContainer>
          <TopExternalLink href={link}>
            <FaSvg icon={faFileContract} mr="2" />
            Learn More
          </TopExternalLink>
        </TopLinksContainer>
      )}
    </Box>
  );
}

const SubTitle = styled(Box)`
  font-size: ${tu.fontSize(2)};
  display: flex;
  flex-wrap: wrap;
  margin-top: ${tu.space(2)};

  a {
    word-break: break-all;
  }
`;
